import { generateUserAgentHeader, urls } from '~/utilities/dataHelpers';
import mediator from '~/utilities/mediator';

type UpdateArgs = {
  osType: string;
  osVersion: string;
  appVersion: string;
  deviceId: string;
};

export const updatePhone = async ({
  updatePhoneData,
  appVersion,
  osType,
  osVersion,
  deviceId,
}: UpdateArgs & {
  updatePhoneData: UpdatePhoneRequest;
}) => {
  if (!updatePhoneData.userID) {
    throw new Error('User ID is required to update phone');
  }

  await mediator.request<ApiResponse<void>>('api:invoke', {
    method: 'PATCH',
    url: `${urls.apiUrl}accounts/${updatePhoneData.userID}/phone`,
    headers: {
      'X-User-Agent': generateUserAgentHeader({
        appVersion,
        osType,
        osVersion,
      }),
      'X-Device-ID': deviceId,
    },
    data: {
      phone: updatePhoneData.phone,
    },
  });
};

export const updateEmail = async ({
  updateEmailData,
  appVersion,
  osType,
  osVersion,
  deviceId,
}: UpdateArgs & {
  updateEmailData: UpdateEmailRequest;
}) => {
  if (!updateEmailData.userID) {
    throw new Error('User ID is required to update email');
  }

  await mediator.request<ApiResponse<void>>('api:invoke', {
    method: 'PATCH',
    url: `${urls.apiUrl}accounts/${updateEmailData.userID}/email`,
    headers: {
      'X-User-Agent': generateUserAgentHeader({
        appVersion,
        osType,
        osVersion,
      }),
      'X-Device-ID': deviceId,
    },
    data: {
      email: updateEmailData.email,
    },
  });
};

export const updatePassword = async ({
  updatePasswordData,
  osType,
  osVersion,
  appVersion,
  deviceId,
}: UpdateArgs & {
  updatePasswordData: UpdatePasswordRequest;
}) => {
  if (!updatePasswordData.userID) {
    throw new Error('User ID is required to update password');
  }

  await mediator.request<ApiResponse>('api:invoke', {
    method: 'PATCH',
    url: `${urls.apiUrl}accounts/${updatePasswordData.userID}/password`,
    headers: {
      'X-User-Agent': generateUserAgentHeader({
        appVersion,
        osType,
        osVersion,
      }),
      'X-Device-ID': deviceId,
    },
    data: {
      password: updatePasswordData.newPassword,
      secondaryAuthentication: {
        email: updatePasswordData.emailConfirmation,
        password: updatePasswordData.currentPassword,
      },
    },
  });
};

// export const getPatient = async ({
//   patientId,
//   appVersion,
//   osType,
//   osVersion,
//   deviceId,
// }: UpdateArgs & {
//   patientId: string;
// }) => {
//   const result = await mediator.request<ApiResponse<Patient>>('api:invoke', {
//     method: 'GET',
//     url: `${urls.apiUrl}patients/${patientId}`,
//     headers: {
//       'X-User-Agent': generateUserAgentHeader({ appVersion, osType, osVersion }),
//       'X-Device-ID': deviceId,
//     },
//   });

//   if (result.data) {
//     return result.data;
//   }

//   throw result;
// };
